<template>
  <div class="alarm-linkage-add">
    <breadcrumb :breadcrumb="breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <form>
      <!--<div class="form-line">-->
        <!--<div class="textBox">-->
          <!--<b class="red">*</b>-->
          <!--<span class="line-text">报警联动名称：</span>-->
        <!--</div>-->
        <!--<el-input v-model="formData.name" size="small" style="width: 280px" />-->
      <!--</div>-->

      <div class="form-line" >
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">报警源：</span>
        </div>
        <el-tabs type="card" style="flex: 1">
          <el-tab-pane label="消防">
            <div class="form-tab-main">
              <div class="form-tab-info">
                <div class="form-tab-device-line" v-for="device in fireControlDeviceList" >
                  <!-- 设备 -->
                  <el-checkbox v-model="device.checked" style="width: 180px;margin-right: 5px;">{{device.deviceName}}</el-checkbox>

                  <!-- 类型 -->
                  <div style="width: 120px;height: 19px;" >
                    <el-checkbox-group v-model="device.checkType"  style="">

                    </el-checkbox-group>
                    <div v-for="type in device.deviceTypeArr" :key="type" style="height: 19px;display: flex;justify-content: flex-start;align-items: center;">
                      <el-checkbox v-model="device[type].typeChecked" @change="deviceTypeChange" style="flex: 1;" :key="type">{{type}}</el-checkbox>
                      <i class="el-icon-damai-shezhi" :style="{color:(currentDeviceConfig.deviceCode === device.deviceCode ? '#409EFF' : '#333333')}" style="padding: 0 10px;cursor: pointer" @click="changeCurrentDeviceCode(device, type)"></i>
                    </div>
                  </div>

                </div>
              </div>
              <!-- 联动事件 -->
              <div class="form-tab-info-right" v-if="currentDeviceConfig.deviceCode">
                <el-tabs type="card" >
                  <el-tab-pane label="消息通知">
                    <div class="event-tab-message-main">
                      <div class="message-person-line" v-for="person in currentDeviceConfig.alarmHandleManList" :key="person.personCode">
                        <!-- 接警人 -->
                        <el-checkbox v-model="person.checked" style="width: 160px;margin-right: 5px;">{{person.personName}}</el-checkbox>

                        <!-- 通知类型 -->
                        <el-checkbox v-model="person.weChat" >微信通知</el-checkbox>
                        <el-checkbox v-model="person.message" >短信</el-checkbox>
                        <el-checkbox v-model="person.phone" >电话</el-checkbox>
                      </div>
                    </div>
                  </el-tab-pane>

                  <el-tab-pane label="视频/抓图">
                    <div class="event-tab-message-main">
                      <div class="message-video-line" v-for="video in currentDeviceConfig.videoDeviceList" :key="video.deviceCode">
                        <!-- 设备 -->
                        <el-checkbox v-model="video.checked" style="width: 160px;margin-right: 5px;">{{video.deviceName}}</el-checkbox>

                        <!-- 用途 -->
                        <div style="flex: 1;height: 19px;">
                          <el-checkbox v-model="video.video" >视频</el-checkbox>
                          <el-checkbox v-model="video.screenShot" >抓图</el-checkbox>
                        </div>
                      </div>
                    </div>
                  </el-tab-pane>

                  <el-tab-pane label="门禁">
                    <div class="event-tab-message-main">
                      <div class="message-access-line" v-for="access in currentDeviceConfig.accessDeviceList" :key="access.deviceCode">
                        <!-- 门禁 -->
                        <el-checkbox v-model="access.checked" style="width: 160px;margin-right: 5px;">{{access.deviceName}}</el-checkbox>

                        <!-- 通知类型 -->
                        <div style="flex: 1;height: 19px;">
                          <el-checkbox v-model="access.openDoor" >开门</el-checkbox>
                        </div>
                      </div>
                    </div>
                  </el-tab-pane>
                </el-tabs>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>

      <!--<div class="form-line" >-->
        <!--<div class="textBox">-->
          <!--<b class="red">*</b>-->
          <!--<span class="line-text">联动事件：</span>-->
        <!--</div>-->
        <!--<el-tabs type="card">-->
          <!--<el-tab-pane label="消息通知">消息通知</el-tab-pane>-->
        <!--</el-tabs>-->
      <!--</div>-->

      <div class="form-btn-box">
        <button-confirm @confirm="confirm" />
        <button-cancel @cancel="cancel" />
      </div>
    </form>
  </div>
</template>

<script>
  import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
  import TextTitle from '../../../components/Text/TextTitle'
  import ButtonConfirm from '../../../components/Button/ButtonConfirm'
  import ButtonCancel from '../../../components/Button/ButtonCancel'
  import {getObjectURL} from '../../../utils/toBase64'
  import $ from 'jquery'
  import {api} from '../../api/Alarm'
  import {nError, nSuccess} from '../../../utils/notice'
  import {errorHandler} from '../../../utils/errorHandler'
  import UploadImgList from '../../../components/Input/UploadImgList'
  import Clipboard from 'clipboard'

  export default {
    components: {
      UploadImgList,
      ButtonCancel,
      ButtonConfirm,
      TextTitle,
      Breadcrumb},
    name: 'alarm-linkage-add',
    data () {
      return {
        breadcrumb: [{
          value: '报警中心',
          name: 'alarm-device-manage'
        }, {
          value: '接警人管理'
        }],
        mainTitle: '报警联动配置',
        subheading: '',

        messageTypeArr: ['微信通知', '短信', '电话'],
        videoTypeArr: ['视频', '抓图'],
        accessTypeArr: ['开门'],
        linkageCode: '',
        formData: {
          name: '',
          ifEnable: '',
        },

        fireControlDeviceList: [],

        currentDeviceConfig: {
          deviceCode: ''
        },

        alarmHandleManList: [],
        videoDeviceList: [],
        accessDeviceList: []
      }
    },
    created () {
      this.linkageCode = this.$route.params.id

      this.getAlarmHandleManList()
      this.getVideoDeviceList()
      this.getAccessDeviceList()

    },
    methods: {
      // 查询联动信息
      getSourceList () {
        this.$axios.post(`${api.getSourceList}`, {
          linkageCode: this.linkageCode
        })
          .then(res => {
            if (res.data.retCode === 1) {
              let resData = res.data.data
              if (resData) {
                this.fireControlDeviceList.map(device => {
                  resData.map(checkedDevice => {
                    if (device.deviceCode === checkedDevice.deviceCode) {
                      device.code = checkedDevice.code
                      device.checked = true
                      device.eventName = '消防'
                      device.alarmType = device.deviceType
                      if (checkedDevice.typeDealMap) {
                        device.typeDealMap = checkedDevice.typeDealMap
                        for(let i in checkedDevice.typeDealMap) {
                          device[i].typeChecked = true
                          // device[i].personList.map(person => {
                          //   person.checked = true
                          // })
                          // device[i].videoDeviceList.map(video => {
                          //   video.checked = true
                          // })
                          // device[i].guardDeviceList.map(guard => {
                          //   guard.checked = true
                          // })
                        }
                      }
                    }
                  })

                })
              }
              console.log(this.fireControlDeviceList)
            }
          })
          .catch(errorHandler('查询失败'))
      },

      // 获取接警人员列表
      getAlarmHandleManList () {
        this.$axios.post(api.getAlarmHandleManList, {})
          .then(res => {
            if (res.data.retCode === 1) {
              let data = res.data.data
              data.map(v => {
                v.checked = false
                v.weChat = false
                v.message = false
                v.phone = false
              })
              this.alarmHandleManList = data
              this.getFcsDeviceList()
            }
          })
          .catch(errorHandler('获取接警人员失败'))
      },

      // 获取视频设备列表
      getVideoDeviceList () {
        this.$axios.post(api.getVideoPassagewayList, {})
          .then(res => {
            if (res.data.retCode === 1) {
              let data = res.data.data
              data.map(v => {
                v.checked = false
                v.video = false
                v.screenShot = false
              })
              this.videoDeviceList = data
            }
          })
          .catch(errorHandler('获取视频设备列表失败'))
      },

      // 获取门禁设备列表
      getAccessDeviceList () {
        this.$axios.post(api.getAccessDeviceList, {})
          .then(res => {
            if (res.data.retCode === 1) {
              let data = res.data.data
              data.map(v => {
                v.checked = false
                v.openDoor = false
              })
              this.accessDeviceList = data

            }
          })
          .catch(errorHandler('获取门禁设备列表失败'))
      },

      // 获取消防设备列表
      getFcsDeviceList () {
        this.$axios.post(`${api.getFcsDeviceList}`, {})
          .then(res => {
            if (res.data.retCode === 1) {
              let resData = res.data.data
              resData.map(v => {
                v.deviceTypeArr = v.deviceType.split(',')
                v.checkType = []
                v.deviceTypeArr.map(type => {
                  v[type] = {}
                  v[type].typeChecked = false
                  v.linkageCode = this.linkageCode
                  // let personList = []
                  // let videoDeviceList = []
                  // let guardDeviceList = []
                  // this.alarmHandleManList.map(v => {
                  //   v.checked = false
                  //   personList.push(v)
                  // })
                  // this.videoDeviceList.map(v => {
                  //   v.checked = false
                  //   videoDeviceList.push(v)
                  // })
                  // this.accessDeviceList.map(v => {
                  //   v.checked = false
                  //   guardDeviceList.push(v)
                  // })
                  // v[type].personList = personList
                  // v[type].videoDeviceList = videoDeviceList
                  // v[type].guardDeviceList = guardDeviceList
                })
              })
              this.fireControlDeviceList = resData
              this.getSourceList()
            }
          })
          .catch(errorHandler('查询失败'))
      },

      // 报警类型选择
      deviceTypeChange (e, r) {
        console.log(e, r)
      },

      // 选择设备修改配置
      changeCurrentDeviceCode (device, type) {
        // 旧设备配置保存
        console.log('已经配置好的：', this.currentDeviceConfig)
        if (this.currentDeviceConfig.deviceCode) {
          let deviceConfigType = this.currentDeviceConfig.deviceConfigType
          this.fireControlDeviceList.map(v => {
            if (v.deviceCode === this.currentDeviceConfig.deviceCode) {
              if (!v.typeDealMap) {
                v.typeDealMap = {}
              }
              v.typeDealMap[deviceConfigType] = {}
              let personListConfig = []
              this.currentDeviceConfig.alarmHandleManList.map(v => {
                if (v.checked) {
                  personListConfig.push(v)
                }
              })
              let videoDeviceListConfig = []
              this.currentDeviceConfig.videoDeviceList.map(v => {
                if (v.checked) {
                  videoDeviceListConfig.push(v)
                }
              })
              let guardDeviceListConfig = []
              this.currentDeviceConfig.accessDeviceList.map(v => {
                if (v.checked) {
                  guardDeviceListConfig.push(v)
                }
              })
              console.log('config:', personListConfig, videoDeviceListConfig, guardDeviceListConfig)
              v.typeDealMap[deviceConfigType].personList = personListConfig
              v.typeDealMap[deviceConfigType].videoDeviceList = videoDeviceListConfig
              v.typeDealMap[deviceConfigType].guardDeviceList = guardDeviceListConfig
            }
          })
        }

        setTimeout(() => {
          // 新设备配置，更新数据
          console.log('报警设备：', device, '报警类型:', type)
          let alarmHandleManListClone = this.deepClone(this.alarmHandleManList)
          let videoDeviceListClone = this.deepClone(this.videoDeviceList)
          let accessDeviceListClone = this.deepClone(this.accessDeviceList)
          let personList = []
          let videoDeviceList = []
          let guardDeviceList = []
          console.log(device.typeDealMap)
          if (!device.typeDealMap) {
            personList = alarmHandleManListClone
            videoDeviceList = videoDeviceListClone
            guardDeviceList = accessDeviceListClone
            // this.alarmHandleManList.map(v => {
            //   this.$set(v, 'checked', false)
            //   this.$set(v, 'weChat', false)
            //   this.$set(v, 'message', false)
            //   this.$set(v, 'phone', false)
            //   personList.push(v)
            // })
            // this.videoDeviceList.map(v => {
            //   this.$set(v, 'checked', false)
            //   this.$set(v, 'video', false)
            //   this.$set(v, 'screenShot', false)
            //   videoDeviceList.push(v)
            // })
            // this.accessDeviceList.map(v => {
            //   this.$set(v, 'checked', false)
            //   this.$set(v, 'openDoor', false)
            //   guardDeviceList.push(v)
            // })
          } else {
            console.log(device.typeDealMap[type])
            if (device.typeDealMap[type].personList) {
              alarmHandleManListClone.map(v => {
                let checkedState = false
                let weChatState = false
                let messageState = false
                let phoneState = false
                device.typeDealMap[type].personList.map(person => {
                  if (person.personCode === v.personCode) {
                    checkedState = person.checked || true
                    weChatState = person.weChat
                    messageState = person.message
                    phoneState = person.phone
                  }
                })
                this.$set(v, 'checked', checkedState)
                this.$set(v, 'weChat', weChatState)
                this.$set(v, 'message', messageState)
                this.$set(v, 'phone', phoneState)
                personList.push(v)
              })
            }
            if (device.typeDealMap[type].videoDeviceList) {
              videoDeviceListClone.map(v => {
                let checkedState = false
                let videoState = false
                let screenShotState = false
                device.typeDealMap[type].videoDeviceList.map(video => {
                  if (video.deviceCode === v.deviceCode) {
                    checkedState = video.checked || true
                    videoState = video.video
                    screenShotState = video.screenShot
                  }
                })
                this.$set(v, 'checked', checkedState)
                this.$set(v, 'video', videoState)
                this.$set(v, 'screenShot', screenShotState)
                videoDeviceList.push(v)
              })
            }
            if (device.typeDealMap[type].guardDeviceList) {
              accessDeviceListClone.map(v => {
                let checkedState = false
                let openDoorState = false
                device.typeDealMap[type].guardDeviceList.map(guard => {
                  if (guard.deviceCode === v.deviceCode) {
                    checkedState = guard.checked || true
                    openDoorState = guard.openDoor
                  }
                })
                this.$set(v, 'checked', checkedState)
                this.$set(v, 'openDoor', openDoorState)
                guardDeviceList.push(v)
              })
            }
          }

          let obj = {
            deviceCode: device.deviceCode,
            deviceConfigType: type,
            alarmHandleManList: personList,
            videoDeviceList: videoDeviceList,
            accessDeviceList: guardDeviceList,
          }
          this.currentDeviceConfig = obj
          console.log(obj)
        })
      },

      // 深拷贝对象
      deepClone (obj) {
        var o;
        // 如果  他是对象object的话  , 因为null,object,array  也是'object';
        if (typeof obj === 'object') {
          // 如果  他是空的话
          if (obj === null) {
            o = null;
          }
          else {
            // 如果  他是数组arr的话
            if (obj instanceof Array) {
              o = [];
              for (let i = 0, len = obj.length; i < len; i++) {
                o.push(this.deepClone(obj[i]));
              }
            }
            // 如果  他是对象object的话
            else {
              o = {};
              for (let j in obj) {
                o[j] = this.deepClone(obj[j])
              }
            }

          }
        }
        else {
          o = obj;
        }
        return o;
      },

      toManagePage () {
        this.$router.push({
          name: 'alarm-linkage'
        })
      },

      confirm () {
        // 是否有配置，需更新保存数据
        if (this.currentDeviceConfig.deviceCode) {
          let deviceConfigType = this.currentDeviceConfig.deviceConfigType
          this.fireControlDeviceList.map(v => {
            if (v.deviceCode === this.currentDeviceConfig.deviceCode) {
              if (!v.typeDealMap) {
                v.typeDealMap = {}
              }
              v.typeDealMap[deviceConfigType] = {}
              let personListConfig = []
              this.currentDeviceConfig.alarmHandleManList.map(v => {
                if (v.checked) {
                  personListConfig.push(v)
                }
              })
              let videoDeviceListConfig = []
              this.currentDeviceConfig.videoDeviceList.map(v => {
                if (v.checked) {
                  videoDeviceListConfig.push(v)
                }
              })
              let guardDeviceListConfig = []
              this.currentDeviceConfig.accessDeviceList.map(v => {
                if (v.checked) {
                  guardDeviceListConfig.push(v)
                }
              })
              console.log('config:', personListConfig, videoDeviceListConfig, guardDeviceListConfig)
              v.typeDealMap[deviceConfigType].personList = personListConfig
              v.typeDealMap[deviceConfigType].videoDeviceList = videoDeviceListConfig
              v.typeDealMap[deviceConfigType].guardDeviceList = guardDeviceListConfig
            }
          })
        }
        let fireControlDeviceChooseList = []
        this.fireControlDeviceList.map(device => {
          if (device.checked) {
            device.eventName = '消防'
            device.alarmType = device.deviceType
            fireControlDeviceChooseList.push(device)
          }
        })
        this.$axios.post(api.addOrUpdate, fireControlDeviceChooseList)
          .then(res => {
            if (res.data.retCode === 1) {
              nSuccess('配置成功')
              this.toManagePage()
            }
          })
          .catch(errorHandler('配置失败'))
      },
      cancel () {
        this.toManagePage()
      },
    },
    watch: {
      'currentDeviceConfig.deviceCode': {
        handler(newName, oldName) {

        },
        deep: true
      }
    }
  }
</script>

<style scoped>
  form {
    width: 90%;
    margin: 0 auto;
    text-align: left;
  }
  .red {
    color: #FF0000;
    vertical-align: sub;
  }
  .form-line {
    margin: 20px 0;
    display: flex;
    justify-content: flex-start;
  }
  .form-line>div {
    margin-right: 20px;
  }
  .line-text{
    color: #48576a;
    font-size: 14px;
    margin-right: 10px;
  }
  .textBox {
    display: inline-block;
    width: 80px;
    line-height: 32px;
    text-align: right;
  }
  .form-btn-box {
    width: 530px;
    padding: 0 110px 0 140px;
    margin: 40px 0 0 0;
    display: flex;
    justify-content: space-between;
  }
  .newly2 {
    display: inline-block;
    width: 250px;
    height: 173px;
    vertical-align: text-top;
    border: 1px dashed #D7D7D7;
    margin-right: 20px;
    position: relative;
  }
  .newly2 span {
    display: block;
    width: 100%;
    color: #999999;
    margin: 0;
    padding: 0;
    text-align: center;
  }
  .newly2 span:first-child {
    font-size: 36px;
    line-height: 120px;
    position: absolute;
    top: 15px;
  }
  .newly2 span:last-child {
    font-size: 14px;
    line-height: 50px;
    position: absolute;
    bottom: 0;
  }
  .upload2 {
    display: inline-block;
    width: 250px;
    height: 173px;
    vertical-align: text-top;
    background-size: 100% 100%;
    position: relative;
  }

  .upload2 img {
    width: 100%;
    height: 100%;
    border-radius: 5px;
  }
  .upload2 b {
    display: inline-block;
    width: 100%;
    line-height: 21px;
    color: white;
    background-color: #989796;
    text-align: center;
    position: absolute;
    bottom: 0;
    opacity: .7;
  }
</style>

<style lang="less">
  .alarm-linkage-add {
    .form-line {
      .el-checkbox__label {
        width: auto;
      }
    }
    .el-tabs__header {
      margin: 0;
    }
    .form-tab-main {
      width: 100%;
      height: 420px;
      border: 1px solid #E4E7ED;
      border-top: 0;
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      .form-tab-info {
        padding: 10px 0 10px 10px;
        height: auto;
        max-height: 410px;
        overflow-y: auto;
        .form-tab-device-line {
          line-height: 40px;
          border-bottom: 1px solid #f6f6f6;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          padding: 0 20px;
          height: 40px;
          .el-icon-damai-shezhi {}
          .el-checkbox {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            .el-checkbox__label {
              overflow: hidden;
              text-overflow:ellipsis;
              white-space: nowrap;
            }
          }
        }
      }

      .form-tab-info::-webkit-scrollbar {/*滚动条整体样式*/
        width: 10px;     /*高宽分别对应横竖滚动条的尺寸*/
        height: 1px;
      }

      .form-tab-info::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
        border-radius: 10px;
        -webkit-box-shadow: inset 0 0 5px rgba(191,191,191,0.8);
        background: #BBBBBB;
      }

      .form-tab-info::-webkit-scrollbar-track {/*滚动条里面轨道*/
        -webkit-box-shadow: inset 0 0 5px rgba(191,191,191,0.8);
        border-radius: 10px;
        background: #EDEDED;
      }

      .form-tab-info-right {
        margin-left: 1px;
        padding: 10px 0;
        flex: 1;
        background-color: #ffffff;

        .event-tab-message-main {
          display: flex;
          justify-content: flex-start;
          flex-direction: column;
          max-height: 340px;
          overflow-y: auto;
          /* 消息通知 */
          .message-person-line {
            padding: 10px 20px;
            display: flex;
            justify-content: flex-start;
          }
          /* 视频抓图 */
          .message-video-line {
            padding: 10px 20px;
            display: flex;
            justify-content: flex-start;
          }
          /* 门禁 */
          .message-access-line {
            padding: 10px 20px;
            display: flex;
            justify-content: flex-start;
          }
        }

      }
    }
  }
  .el-switch {
    height: 30px;
  }
</style>




// WEBPACK FOOTER //
// src/view/AlarmManage/AlarmLinkage/AlarmLinkageAdd.vue